<template>
  <b-container fluid >
    <b-row class="mb-3"
           align-v="center"
           align-h="around"
           cols-xl="2"
           cols="1">
      <b-col class="column">
        <img :src="contents[0].imageUrl"
             alt="chart"/>
      </b-col>
      <b-col class="column"
             v-if="contents[1].content.length > 0">
        <survey-tendency-comparison-by-employee-journey-table :slide="slide"
                                                              :items="contents[1].content"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SurveyTendencyComparisonByEmployeeJourneyTable
  from "@/components/survey/SurveyTendencyComparisonByEmployeeJourneyTable.vue";

export default {
  components: { SurveyTendencyComparisonByEmployeeJourneyTable },
  props: ['slide'],
  computed: {
    contents() {
      return this.slide.content;
    }
  }
}
</script>

<style scoped>
img {
    width: 100%;
}
</style>